import { Link } from 'react-router-dom';
import { mangaCategories } from '@/mocks/manga';

export default function CategoryNav() {
  const mainCategories = mangaCategories.slice(0, 5);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-6 md:mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            漫画分类
          </h2>
          <Link
            to="/category/all"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-sm text-foreground-500 hover:text-accent-500 transition-colors ml-auto whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-5 gap-3 md:gap-4">
          {mainCategories.map((cat) => (
            <Link
              key={cat.id}
              to={cat.id === 'all' ? '/category/all' : `/category/${cat.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group flex flex-col items-center gap-3 p-4 md:p-6 rounded-lg bg-background-100 hover:bg-accent-100 transition-colors"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-500/10 text-accent-500 group-hover:bg-accent-500 group-hover:text-white transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-accent-600 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}